import {parseBool} from "./common";

let rater = require("rater-js");

export const rating = (selectors) => {
    selectors.forEach(item => {
        let score = parseInt(item.dataset.score || 4);
        let readonly = parseBool(item.dataset.readonly || true);
        let input = document.createElement('input');
        input.value = score;
        input.type = "hidden";
        input.name = "rate";
        item.append(input);
        rater({
            element: item,
            readOnly: readonly,
            rating: score,
            rateCallback: function rateCallback(rating, done) {
                this.setRating(rating);
                item.querySelector(['[name="rate"]']).value = this.rating
                done();
            }
        })
    });
}
